import { Validators, FormBuilder } from '@angular/forms';

export let dialogValidationMessages: {} = {
  text: {
    'required': 'Данное поле обязательно для заполнения.',
    'maxlength': 'Длина ввода не может превышать 191 символ.',
    'pattern': 'В начале лишний пробел.',
  },
};

export function getDialogControlsConfig(model, fb: FormBuilder) {
  return {
    text: [model.text, [Validators.required, Validators.pattern(/^\S+/), Validators.maxLength(191)]],
  };
}





// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/dialog-communications/dialog.communications.form.ts